import { debounceTime, map, merge } from 'rxjs';
import { ChangeDetectorRef } from '@angular/core';
import {
    hybridIframeBounds$,
    hybridIframeContainer$,
    hybridIframeCustomStyles$,
    hybridIframeRenderType$,
    hybridIframeSourceUrl$
} from './hybrid-iframe-manager.service';

export const hybridIframeStateChanged$ = merge(
    hybridIframeContainer$,
    hybridIframeCustomStyles$,
    hybridIframeSourceUrl$,
    hybridIframeBounds$,
    hybridIframeRenderType$
).pipe(
    map((t) => void 0),
    debounceTime(100)
);

export function registerHybridIframePositioningChangeDetection(changeDetector: ChangeDetectorRef) {
    hybridIframeStateChanged$.subscribe((s) => {
        setTimeout(() => changeDetector.detectChanges());
    });
}
